import { render, staticRenderFns } from "./Qian10da.vue?vue&type=template&id=d5e35624&scoped=true"
import script from "./Qian10da.vue?vue&type=script&lang=js"
export * from "./Qian10da.vue?vue&type=script&lang=js"
import style0 from "./Qian10da.vue?vue&type=style&index=0&id=d5e35624&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e35624",
  null
  
)

export default component.exports